/**
 * Validate aircraft max weight by class
 *
 * @param field
 * @returns {boolean}
 */
export default function (field) {
	if(! field || !field.hasOwnProperty('value')) {
		return true
	}

	// Convert the value to a string and then to a numeric value.
	const stringValue = typeof field.value === 'string' ? field.value : field.value.toString()
	const numericValue = Number(stringValue.replace(/,/g, ''))
	const group = field.getGroupValues()

	let maxWeight = 1430
	if (Object.prototype.hasOwnProperty.call(group, 'aircraft_class')) {
		if ('Class 1' === group.aircraft_class) {
			maxWeight = 150
		}

		if ('Class 2' === group.aircraft_class) {
			maxWeight = 254
		}
	}

	return numericValue <= maxWeight
}
